import { render, staticRenderFns } from "./News1.vue?vue&type=template&id=a3ea5798&scoped=true&"
import script from "./News1.vue?vue&type=script&lang=js&"
export * from "./News1.vue?vue&type=script&lang=js&"
import style0 from "./News1.vue?vue&type=style&index=0&id=a3ea5798&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ea5798",
  null
  
)

export default component.exports